import { render } from "./TeachersPreview.vue?vue&type=template&id=528ebe93&scoped=true"
import script from "./TeachersPreview.vue?vue&type=script&lang=js"
export * from "./TeachersPreview.vue?vue&type=script&lang=js"

import "./TeachersPreview.vue?vue&type=style&index=0&id=528ebe93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528ebe93"]])

export default __exports__